"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));

var _styledComponents = require("styled-components");

var _styles = require("./styles");

var _Tooltip = require("./Tooltip.placement");

var _Tooltip2 = _interopRequireDefault(require("./Tooltip.sizes"));

var _excluded = ["size", "placement", "label", "trigger", "children"];

var Tooltip = function Tooltip(_ref) {
  var size = _ref.size,
      placement = _ref.placement,
      label = _ref.label,
      trigger = _ref.trigger,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var TooltipSize = _Tooltip2.default[size];
  var TooltipOffset = (0, _Tooltip.alignOffset)(placement);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.GlobalStyle, {
    size: TooltipSize
  }), /*#__PURE__*/_react.default.createElement(_rcTooltip.default, Object.assign({
    overlayClassName: "ds-tooltip",
    placement: placement,
    overlay: label,
    trigger: trigger,
    align: {
      offset: TooltipOffset
    }
  }, rest), children));
};

Tooltip.defaultProps = {
  label: 'label',
  placement: 'top',
  size: 'sm'
};

var _default = (0, _styledComponents.withTheme)(Tooltip);

exports.default = _default;